import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "form" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "label"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 0,
  class: "label"
}
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 4 }

import MyFilter from "~/cabinet/vue/interface/filter/MyFilter.vue";
import ObjectHelper from "~/ts/library/ObjectHelper";
import {__} from "~/ts/library/Translate";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import {computed, ref, watch} from "vue";
import {IFiltersData} from "~/cabinet/vue/interface/filter/Interfaces";
import OperatorApplicationSearchDialogFormInterface
    from "~/operatorApplication/vue/dialogs/OperatorApplicationSearchDialogFormInterface";
import {asyncComputed} from "@vueuse/core";
import useObjectModel from "~/ts/vuePlugins/useObjectModel";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "OperatorApplicationSearchDialogForm"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    buddyList: {},
    sites: {},
    getFilters: { type: Function },
    isVisible: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

let props = __props;

let _model = _useModel<OperatorApplicationSearchDialogFormInterface>(__props, "modelValue");
let model = useObjectModel(_model, () => ({
    siteIds: [],
    filters: {
        dateTime: {
            DATE_CURRENT_DAY: [null]
        }
    },
    query: null,
    descr: null
}));

function initModel() {
    if (isCustomList.value) {
        let search = ObjectHelper.jsonClone(props.buddyList.customListSearch);
        model.value.siteIds = search.siteIds;
        model.value.filters = JSON.parse(search.filters);
        model.value.query = search.query;
        model.value.descr = props.buddyList.descr;
    }
}

watch(computed(() => props.isVisible), () => initModel());


if (props.sites.length == 1) {
    model.value.siteIds = [props.sites[0].id];
}

let isCustomList = computed(() => {
    return !props.buddyList.isSystem;
});

const isFiltersLoading = ref(false)

let filtersData = asyncComputed(async () => {
    if (props.getFilters) {
        let siteIds = model.value.siteIds;
        return await props.getFilters(siteIds.length == 1 ? siteIds[0] : null);
    } else {
        return null;
    }
}, null, isFiltersLoading);

initModel();



return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isCustomList))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(__)('Название')) + ":", 1),
          _createVNode(_component_el_input, {
            modelValue: _unref(model).descr,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(model).descr) = $event))
          }, null, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    (__props.sites.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_unref(isCustomList))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(__)('Сайты')) + ": ", 1))
            : _createCommentVNode("", true),
          _createVNode(_component_el_select, {
            modelValue: _unref(model).siteIds,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(model).siteIds) = $event)),
            class: "w-100 mb-2",
            multiple: "",
            placeholder: _unref(__)('Все сайты')
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sites, (site) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: site.id,
                  value: site.id,
                  label: site.title
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]))
      : _createCommentVNode("", true),
    (__props.getFilters)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_unref(isCustomList))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(__)('Фильтры')) + ": ", 1))
            : _createCommentVNode("", true),
          (_unref(filtersData) && !isFiltersLoading.value)
            ? (_openBlock(), _createBlock(MyFilter, {
                key: 1,
                "filters-data": _unref(filtersData),
                modelValue: _unref(model).filters,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(model).filters) = $event)),
                "with-search": "",
                search: _unref(model).query,
                "onUpdate:search": _cache[3] || (_cache[3] = ($event: any) => ((_unref(model).query) = $event)),
                placeholder: _unref(__)('Введите поисковый запрос или добавьте фильтры')
              }, null, 8, ["filters-data", "modelValue", "search", "placeholder"]))
            : (_openBlock(), _createBlock(MyLoader, { key: 2 }))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_el_input, {
            modelValue: _unref(model).query,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(model).query) = $event)),
            placeholder: _unref(__)('Введите номер телефона или Email')
          }, null, 8, ["modelValue", "placeholder"])
        ])),
    (_ctx.$slots.buttons)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _renderSlot(_ctx.$slots, "buttons")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})